import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { catchError, map } from 'rxjs/operators';
import { GoogleMap } from '@angular/google-maps';
import { Observable, of } from 'rxjs';
import { MapService } from 'src/app/core/services/map.service';
import { DatePipe } from '@angular/common';
import { UtilService } from 'src/app/core/services/util.service';
import { environment } from 'src/environments/environment';
import { Loader } from '@googlemaps/js-api-loader';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [DatePipe],
})
export class MapComponent implements OnInit, AfterViewInit {
  constructor(
    public toastService: ToastService,
    public mapService: MapService,
    public datePipe: DatePipe,
    private utilService: UtilService
  ) {}
  options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 4,
  };

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });

  maps: any;

  circularProgressiveWait: boolean = false;
  countValues = 0;

  ufLst: string[] = [];
  cityLst: { name: string; lat: string; lng: string }[] = [];
  circularProgressiveCity = false;

  heatMapP2PDenoxItem: any[] = [];
  heatMapP2PDenox: google.maps.visualization.HeatmapLayer[] = [];
  filterTimeHeatMap = 86400;
  heatMapWeight = true;

  mapSelect = 0;

  //Tower LoRaWAN
  mapRadiusTower = false;
  markerMapTowerLoRaWAN: any[] = [];
  markerMapTowerLoRaWANCircle: any[] = [];

  private async initializeMap() {
    await this.loader.importLibrary('visualization');
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );
  }

  ngAfterViewInit() {
    this.initializeMap();
  }

  ngOnInit(): void {
    this.utilService.getUF().subscribe((response: any) => {
      this.ufLst = response;
    });
  }

  changeGradient() {
    const gradient = [
      'rgba(0, 255, 255, 0)',
      'rgba(0, 255, 255, 1)',
      'rgba(0, 191, 255, 1)',
      'rgba(0, 127, 255, 1)',
      'rgba(0, 63, 255, 1)',
      'rgba(0, 0, 255, 1)',
      'rgba(0, 0, 223, 1)',
      'rgba(0, 0, 191, 1)',
      'rgba(0, 0, 159, 1)',
      'rgba(0, 0, 127, 1)',
      'rgba(63, 0, 91, 1)',
      'rgba(127, 0, 63, 1)',
      'rgba(191, 0, 31, 1)',
      'rgba(255, 0, 0, 1)',
    ];

    this.heatMapP2PDenox[0]?.set(
      'gradient',
      this.heatMapP2PDenox[0]?.get('gradient') ? null : gradient
    );
    this.heatMapP2PDenox[0]?.setMap(null);
    this.heatMapP2PDenox[0]?.setMap(this.maps);
  }

  changeWeight(buttonValue: any) {
    this.heatMapWeight = !buttonValue._checked;
    if (this.heatMapP2PDenoxItem.length > 0) {
      this.circularProgressiveWait = true;
      var coordsData: any = [];
      if (this.heatMapWeight) {
        coordsData = this.heatMapP2PDenoxItem;
      } else {
        this.heatMapP2PDenoxItem.forEach((item: any) => {
          coordsData.push(item.location);
        });
      }

      this.heatMapP2PDenox[0]?.setData(coordsData);
      this.heatMapP2PDenox[0]?.setOptions({ opacity: 1 });
      this.heatMapP2PDenox[0]?.setMap(null);
      this.heatMapP2PDenox[0]?.setMap(this.maps);
      this.circularProgressiveWait = false;
    }
  }

  geHeatMapData() {
    this.circularProgressiveWait = true;
    if (this.mapSelect == 0) {
      this.mapP2PDenox();
    } else if (this.mapSelect == 1) {
      this.mapTowerLoRaWAN();
    }
  }

  changeRadius(buttonValue: any) {
    this.mapRadiusTower = !buttonValue._checked;
  }

  cleanMap() {
    try {
      this.heatMapP2PDenox.forEach((item: any) => {
        item.setMap(null);
      });
    } catch {}
    try {
      this.markerMapTowerLoRaWAN.forEach((item: any) => {
        item.setMap(null);
      });
      this.markerMapTowerLoRaWANCircle.forEach((item: any) => {
        item.setMap(null);
      });
    } catch {}
    this.heatMapP2PDenox = [];
    this.heatMapP2PDenoxItem = [];
    this.markerMapTowerLoRaWANCircle = [];
    this.markerMapTowerLoRaWAN = [];
    this.countValues = 0;
  }

  changeMap() {
    if (this.mapSelect == 1) {
      this.filterTimeHeatMap = -1;
    } else {
      this.filterTimeHeatMap = 86400;
    }
    this.cleanMap();
  }

  openCoverageMapLorawan() {
    window.open('https://coverage.sh/share/6YP3PmCar9oN3pt_');
  }
  mapTowerLoRaWAN() {
    this.cleanMap();
    this.mapService
      .getMapTowerLoRaWANData(String(this.filterTimeHeatMap))
      .subscribe(
        (response: any) => {
          if (response != undefined) {
            let coordsData: any[] = [];
            this.countValues = response.length;
            response.forEach((item: any) => {
              let coords = item.location.split(';');

              var dateLastUpdate = null;
              try {
                dateLastUpdate = this.datePipe.transform(
                  new Date(Number(item.lastUpdate)).toUTCString(),
                  'dd-MM-yyyy HH:mm:ss'
                )!;
              } catch (error) {}
              const marker = new google.maps.Marker({
                position: new google.maps.LatLng(coords[0], coords[1]),
                icon: '../../../../assets/images/tower.png',
                title: `<p><span style="color: #ff0000;"><strong>${
                  dateLastUpdate ?? ''
                }</strong></span></p>`,
                optimized: true,
              });

              let infowindow = new google.maps.InfoWindow({
                content: ` <div style="line-height: 0.5;">
              <br></br>
              <p><strong>Última Atualização:</strong> ${
                dateLastUpdate ?? ''
              }</p>
              <p><strong>Serial:</strong> ${item.serial ?? ''}</p>
              <p><strong>Raio(m):</strong> ${item.radius ?? ''}</p>

              </div>
              `,
              });
              marker.addListener('click', () => {
                infowindow.open({
                  anchor: marker,
                  shouldFocus: false,
                });
              });
              if (item.radius != undefined && this.mapRadiusTower) {
                const markerCircle = new google.maps.Circle({
                  center: marker.getPosition(),
                  draggable: false,
                  strokeColor: '#3e1451',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: '#FFFFFF',
                  fillOpacity: 0.35,
                  radius: Number(item.radius ?? 0),
                });
                markerCircle.setMap(this.maps);
                this.markerMapTowerLoRaWANCircle.push(markerCircle);
              }

              marker.setMap(this.maps);
              this.markerMapTowerLoRaWAN.push(marker);
            });
          }
          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          //alert(error.message);
          this.toastService.show('Erro ao pesquisar - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        }
      );
  }

  mapP2PDenox() {
    this.cleanMap();
    this.mapService
      .getHeatMapP2PDenoxData(String(this.filterTimeHeatMap))
      .subscribe(
        (response: any) => {
          if (response != undefined) {
            let coordsData: any[] = [];
            this.heatMapWeight
              ? (this.countValues = 0)
              : (this.countValues = response.length);
            response.forEach((item: any) => {
              let coords = item.location.split(';');
              this.heatMapP2PDenoxItem.push({
                location: new google.maps.LatLng(coords[0], coords[1]),
                weight: Number(item.weight),
              });
              if (this.heatMapWeight) {
                coordsData.push({
                  location: new google.maps.LatLng(coords[0], coords[1]),
                  weight: Number(item.weight),
                });
                this.countValues = this.countValues + Number(item.weight);
              } else {
                coordsData.push(new google.maps.LatLng(coords[0], coords[1]));
              }
            });

            const heatmap: google.maps.visualization.HeatmapLayer =
              new google.maps.visualization.HeatmapLayer();
            heatmap.setData(coordsData);
            this.heatMapP2PDenox.push(heatmap);
            heatmap.setMap(this.maps);
          }
          this.circularProgressiveWait = false;
        },
        (error: HttpErrorResponse) => {
          //alert(error.message);
          this.toastService.show('Erro ao pesquisar - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.circularProgressiveWait = false;
        }
      );
  }

  getCity(uf: any) {
    this.cityLst = [];
    if (uf != undefined) {
      this.circularProgressiveCity = true;

      this.utilService
        .getCity(uf.$ngOptionLabel.trim())
        .subscribe((response: any) => {
          response.forEach((item: any) => {
            let itemSplit = item.split(';');
            this.cityLst.push({
              name: itemSplit[0],
              lat: itemSplit[1],
              lng: itemSplit[2],
            });
            this.circularProgressiveCity = false;
          });
        });
    } else {
      this.cityLst = [];
    }
  }
  changeMapOnChangeCity(city: string) {
    if (city != undefined) {
      let cityAux = this.cityLst.filter((item: any) => {
        return city == item.name;
      });
      this.maps.setCenter(
        new google.maps.LatLng({
          lat: Number(cityAux[0].lat),
          lng: Number(cityAux[0].lng),
        })
      );
      this.maps.setZoom(10);
    }
  }
}
